<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      label="Assign Outcome"
      option-label="name"
      option-value="id"
      :emit-value="true"
      map-options
      :outlined="outlined"
      :dense="dense"
      :loading="outcomesLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        default: null,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        outcomes: "outcomes/list",
        outcomesLoading: "outcomes/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      outcomes: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.outcomes));
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.outcomes));
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.outcomes.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
